<template>
<div>
  <v-container fluid class="mb-5">
    <v-row justify="start">

        <v-col cols="12" class="d-flex text-left">
            <DialogKyukaShinsei class="mr-6" ref="dialog_shinsei" :arr_staff="arr_staff" :isSameroute="true" @getlist="getList"></DialogKyukaShinsei>
            <DialogKyukaSearch class="mr-6"  :arr_staff="arr_staff" :isSameroute="true" @search="search" @getkyukalist="getList"></DialogKyukaSearch>



                <v-btn @click="csv_download()" class="mygreen white--text mr-4"> CSVエクスポート </v-btn>



            <DialogKyukaSasimodosi ref="dialog_sasimodosi" :arr_staff="arr_staff" :isSameroute="true" @getkyukalist="getList"></DialogKyukaSasimodosi>
            <DialogKyukaDelete ref="dialog_delete" :isSameroute="true"  @getkyukalist="getList"></DialogKyukaDelete>
        </v-col>

    </v-row>
  </v-container>


  <v-data-table
 v-if="saibyouga"
    fixed-header
    :headers="headers"
    :items="records"
    :items-per-page="20"
    sort-by="calories"
    class="elevation-1"
    :height="tableHeight"
    @click:row="rowClick"
  >

    <template v-slot:item.name="{ item }">
        <div v-html="item.name"></div>
    </template>
    <template v-slot:item.reason="{ item }">
        <v-tooltip bottom> 
            <template v-slot:activator="{ on, attrs }">
            <div
              v-bind="attrs"
              v-on="on"
            >{{ item.reason.slice(0, 27) + (item.reason.length>=27  ? '...' : '') }}</div>
            </template>
            <span>{{item.reason}}</span>
        </v-tooltip>
    </template>

    <template v-slot:item.rejection="{ item }">
        <v-tooltip bottom> 
            <template v-slot:activator="{ on, attrs }">
            <div
              v-bind="attrs"
              v-on="on"
            >{{ item.rejection.slice(0, 27) + (item.rejection.length>=27  ? '...' : '') }}</div>
            </template>
            <span>{{item.rejection}}</span>
        </v-tooltip>
    </template>


    <template v-slot:item.status="{ item }">
          <div :class="{myred: is_red(item)}">{{item.status}}</div>
    </template>
    <template v-slot:item.actions="{ item }">
          <div v-if="check_auth(item)" class="text-center">
            <v-menu
              top
              :offset-x="true"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                 v-if="arr_hensyu(item).length>0"
                  color="#f5f5f5"
                  v-bind="attrs"
                  v-on="on"
                >
                  ・・・
                </v-btn>
              </template>

              <v-list>
                <v-list-item
                  v-for="(v, index) in arr_hensyu(item)"
                  :key="index"
                  @click="do_action(item, v)"
                >
                  <v-list-item-title>{{ v }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
    </template>


    <template v-slot:no-data>
    データがありません.
    </template>


  </v-data-table>
</div>
</template>


<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import myMixin from '@/mixin.js';
import axios from 'axios';
import {mapGetters} from 'vuex'
import DialogKyukaSearch from '@/components/DialogKyukaSearch.vue';
import DialogKyukaShinsei from '@/components/DialogKyukaShinsei.vue';
import DialogKyukaSasimodosi from '@/components/DialogKyukaSasimodosi.vue';
import DialogKyukaDelete from '@/components/DialogKyukaDelete.vue';
import saveAs from "file-saver";
/* eslint-disable */


export default {

  mixins: [myMixin],
  components:{
      DialogKyukaSearch,
      DialogKyukaShinsei,
      DialogKyukaSasimodosi,
      DialogKyukaDelete,
  },

  data(){  // datas
      return {
        csvData: [],
        labels: {
            name: {title: "スタッフ名"},
            kibou: {title: "取得希望日時"},
            syubetu: {title: "休暇種別"},
            reason: {title: "取得理由"},
            rejection: {title: "差し戻し理由"},
            status: {title: "ステータス"},
            updated_at: {title: "更新日時"},
        },
        records: [],
        saibyouga: true,
        arr_staff: [],
        modal: false,
        tableHeight: 700,
        dialog: false,
        dialogDelete: false,
        headers: [
          {
            text: 'スタッフ名',
            align: 'start',
            value: 'name',
          },
          { text: '取得希望日時', value: 'kibou' },
          { text: '休暇種別', value: 'syubetu' },
          { text: '取得理由', value: 'reason', width: '20%' },
          { text: '差し戻し理由', value: 'rejection', width: '20%' },
          { text: 'ステータス', value: 'status' },
          { text: '操作', value: 'actions', sortable: false },  // v-slot:item.actions と紐付いている
        ],
        editedIndex: -1,
        editedItem: {
          name: '',
          calories: 0,
          fat: 0,
          carbs: 0,
          protein: 0,
        },
        defaultItem: {
          name: '',
          calories: 0,
          fat: 0,
          carbs: 0,
          protein: 0,
        },
      }
  },
    computed: {
        ...mapGetters(['user', 'user_name', 'is_admin']),
    },

  watch: {

  },

  async created () {
      console.log('%ccreated: KyukaView.vue', mycolor.created);
      this.get_staffs();
      this.records = await this.getKyukaList();

  },

  mounted () {
    console.log('mounted');
  },

  methods: {
      async getList(){
          this.records = await this.getKyukaList();
          this.saibyouga = false;
          this.$nextTick( () => (this.saibyouga = true) );
      },
      csv_download(){
          console.log(this.records);

          axios.post(
              '/download_kyuka_csv',
              this.records,
          )
            .then( (res) => {

                console.group();
                console.log('%c %s', mycolor.api, '/download_kyuka_csv');
                console.log(res);
                console.groupEnd();

                  let mineType = res.headers["content-type"];
                  const name = res.headers["content-disposition"];
                  const bom = new Uint8Array([0xef, 0xbb, 0xbf]); // utf-8で文字化けさせないためにBOMを付ける
                  const blob = new Blob([bom, res.data], { type: 'text/csv', });


                  // ファイル名決める
                  let today = new Date();
                  // today.toLocaleString();   // 時間まで欲しければこっち! '2022/8/23 9:07:28'
                  let today_text = today.toLocaleDateString();  // '2022/8/23'
                  let yyyy = today_text.replace(/^(\d+)\/(\d+)\/(\d+)/mg, '$1');
                  let mm = today_text.replace(/^(\d+)\/(\d+)\/(\d+)/mg, '$2').padStart(2, '0');
                  let dd = today_text.replace(/^(\d+)\/(\d+)\/(\d+)/mg, '$3').padStart(2, '0');

                  let CSV_NAME = yyyy + mm + dd + '.csv';

                  saveAs(blob, CSV_NAME);

            })
            .catch(() => {
              console.error('error');
            });

          return false;


      },
      arr_hensyu(item){
          if( this.user.auth==='一般' ){
              var myarr = ['編集'];
              // 一般ユーザーは'承認待ち','差し戻し'のみ削除できる
              if(item.status==='承認待ち' || item.status==='差し戻し'){
                  console.log();
                  myarr.push('削除');
              }
              if(item.status==='承認'){
                    // 一般ユーザーは承認後何もできない
                    myarr =[];
              }

              return myarr;
          }else{
              var myarr = ['編集', '承認', '差し戻し', '削除'];
              if(item.status==='承認'){
                    myarr =['削除'];
                    //myarr = myarr.filter(v => {
                    //    return v!='編集' && v!='承認' && v!='差し戻し'
                    //});
              }
              return myarr;
          }
      },
      is_red(item){
          if( (this.user.auth=='管理者' || this.user.auth=='チーフ') && item.status==='承認待ち' ){
              return true;
          }

          if( item.status==='差し戻し' && item.name==this.user.name){
              console.log('差し戻し');
              return true;
          }else{
              return false;
          }

      },
      check_auth(item){
          // 権限チェック

          if( (this.user.auth=='管理者' || this.user.auth=='チーフ') ){
              return true;
          }


          if(  item.name==this.user.name ){
              return true;
          }else{
              return false;
          }

      },
      do_action(item, v){
          console.log('do_action()');
          var kyuka_id = item.id;
          var staff_id = item.staff_id;
          var start = item.start;
          var end = item.end;
          var reason = item.reason;
          var syubetu = item.syubetu;
          console.log('item:', item);
          console.log('kyuka_id', kyuka_id);
          console.log('start', start);
          console.log('end', end);
          console.log('v', v);

          // 承認以外はダイアログをopenするだけ
          if(v==='削除'){
              this.$refs.dialog_delete.open(item);
              return false;
          }
          if(v==='編集'){
              this.$refs.dialog_shinsei.open(item);
              return false;
          }
          if(v==='差し戻し'){
              this.$refs.dialog_sasimodosi.open(item);
              return false;
          }


          // 承認
          axios.post('/kyuka_syounin/'+staff_id+'/'+kyuka_id,  {kyuka_id:kyuka_id, status:v, staff_id: staff_id, start: start, end: end, reason: reason, syubetu: syubetu} )
            .then((res) => {
                console.group();
                console.log('%c /kyuka_syounin', mycolor.api);
                console.log(res.data);
                console.groupEnd();

                this.getList();  // リスト再取得

                // メール送信
                if(res.data.status=='OK'){

                      // todo: メール送信
                      axios.post('/send_kyuka_mail/4', {kyuka_id:kyuka_id})
                      .then( (res) => {
                          console.group();
                          console.log('%c /send_kyuka_mail/4', mycolor.api);
                          console.log(res);
                          console.groupEnd();

                      })
                      .catch();

                }else{
                  console.log(res.data.msg);
                  alert(res.data.msg);
                }
            })
            .catch( e => { console.error(e); });
      },

      get_staffs(){
          axios.get('/get_staffs')
            .then((res) => {
              console.group()
              console.log('スタッフドロップダウン取得');
              console.log('%c /get_staffs', mycolor.api);
              console.log(res.data);
              console.groupEnd();

              // 管理者は除外
              this.arr_staff =res.data.filter( v => {
                    return v.id!=0;
              });


            })
            .catch((error) => {
              // eslint-disable-next-line
              console.error(error);
            });
      },
      async search(data){
          console.log('%c %s', mycolor.strong, 'search()');
          console.log( data );

          this.records = await this.getKyukaList();

          console.log(this.records)


          if(data.staff_selected){
              this.records  = this.records.filter(v => {
                  console.log(v);
                  console.log('data: ', data);
                  return v.staff_id === data.staff_selected;
              });
          }
          if(data.syubetu_selected){
              this.records = this.records.filter(v => {
                  return v.syubetu === data.syubetu_selected;
              });
          }
          if(data.from){
              this.records = this.records.filter(v => {
                  const x = new Date(v.start);
                  const y = new Date(data.from);
                  return x>=y;
              });
          }
          if(data.to){
              this.records = this.records.filter(v => {
                  const x = new Date(v.end);
                  const y = new Date(data.to);
                  return x<=y;
              });
          }
          if(data.status.length>0){
              let tmp_arr = []
                  this.records.forEach( item => {
                      if( data.status.includes(item.status) ){
                          tmp_arr.push(item);
                      }
                  });
                  this.records = tmp_arr;
          }
          console.log('%c %s', mycolor.strong, 'filter complite');
          console.log(this.records)
      },


      yuukyuu(item){
          console.log('yuukyuu');
          console.log(item);
          return false;

      },

      rowClick(v){
          console.log('rowClick');
          console.log(v);
          return false;
      },


    // 初期化
    async getKyukaList () {

      console.log('========== getKyukaList() ==========');

      this.setToken();
      let res = await axios.get('/kyuka_list')
        .then((res) => {

          console.log('%c /kyuka_list', mycolor.api);
          console.log(res.data);


          if(!this.is_admin){
              console.log('%c %s', mycolor.strong, 'フィルタリング');
              console.log(this.records);
              // フィルタリング
              res.data = res.data.filter( v => {
                  return v.staff_id === this.user.id;
              });
          }


          return res.data
        })
        .catch((error) => {
                      alert('トークンが有効期限切れです.ログインし直してください.');

                      console.log('logout()');
                      localStorage.clear('user');
                      this.$store.dispatch( 'user', null );
                      this.$store.dispatch( 'notices', [] );
                      this.$router.push( { name:'login', query:{from: this.$route.name} } ).catch(()=>{});
        });
        console.log('休暇一覧取得完了！');
        return res;

    },  // getKyukaList()



  },  // methods
}  // export default
</script>

<style scoped>
/deep/ .kana{
    font-size: 9px;
}
/deep/ .myred{
    color: red;
}
</style>
